module.exports = __webpack_public_path__ + "media/images/mime_types/file-word-o-4799489ff9e730d7f320a0f89b4d101a.png";